// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"152":"dc60915fc8200f7f","158":"dfe28db5faf2b520","431":"f23a82310691e2eb","461":"24a4a01815123fe1","594":"de61b9623ffe3d91","685":"6a49337a0e449288","846":"895afdf9b901fae4","924":"8cd3ecaa23f6d34c","957":"1684ff3353d80ff3","979":"34d621a28a1ee026","986":"48364cef1d0a581a"}[chunkId] + ".js";
};